// src/components/FAQ.js
import React, { useState } from 'react';
import './FAQ.css'; // Import the CSS file

// Data for your FAQs (hardcoded in this component, matching your HTML)
const faqData = [
  {
    question: "How do I place an order?",
    answer: "You can place an order through the IronBhai mobile app or website. Select your service, choose a pickup slot, and confirm your booking."
  },
  {
    question: "What services do you offer?",
    answer: "We provide laundry, ironing, dry cleaning, saree rolling, and special garment care services."
  },
  {
    question: "What are your service hours?",
    answer: "We operate 7 days a week, from 8:00 AM to 9:00 PM. Timings may vary on public holidays."
  },
  {
    question: "How much do your services cost?",
    answer: "Prices are listed in the app and vary depending on the garment type and service chosen."
  },
  {
    question: "Do you offer home pickup and delivery?",
    answer: "Yes, we provide doorstep pickup and delivery for all orders."
  },
  {
    question: "How long does it take to process my order?",
    answer: "Most orders are completed within 24–48 hours. Delicate or special items may take longer."
  },
  {
    question: "What if I miss my pickup or delivery?",
    answer: "You can reschedule through the app or contact customer support to arrange a new time."
  },
  {
    question: "Do you guarantee stain removal?",
    answer: "We do our best to remove stains, but 100% removal cannot be guaranteed, especially for old or set-in stains."
  },
  {
    question: "How can I pay?",
    answer: "We accept online payments (UPI, cards, net banking) and Cash on Delivery (COD) where available."
  },
  {
    question: "What if my garment is damaged or lost?",
    answer: "If damage or loss occurs due to our negligence, compensation will be provided as per our Terms &amp; Conditions."
  },
  {
    question: "Do you offer discounts or promotions?",
    answer: "Yes! Check the app’s “Offers” section or our social media pages for the latest deals."
  },
  {
    question: "How can I contact customer support?",
    answer: `📧 Email: support@ironbhai.com<br>
             📞 Contact: +91 8688206969<br>
             💬 WhatsApp: <a href="https://wa.me/918688206969?text=Hello%20IronBhai%2C%20I%20need%20help" target="_blank">Chat With Us</a>`
  }
];

// Individual FAQ Item Component
function FAQItem({ question, answer, index }) {
  const [isActive, setIsActive] = useState(false); // State to manage active/collapsed

  const toggleActive = () => {
    setIsActive(!isActive);
  };

  return (
    // Apply 'active' class based on isActive state
    <div className={`faq ${isActive ? 'active' : ''}`} onClick={toggleActive}>
      <h2>{`${index + 1}. ${question}`}</h2>
      {/* Use dangerouslySetInnerHTML for HTML content in answer */}
      <p dangerouslySetInnerHTML={{ __html: answer }}></p>
    </div>
  );
}

// Main FAQ Component
function FAQ() {
  return (
    <div className="faq-container"> {/* Added a container div for overall styling */}
      <h1>Frequently Asked Questions (FAQs)</h1>
      {faqData.map((faq, index) => (
        <FAQItem
          key={index} // Using index as key is generally okay for static lists
          question={faq.question}
          answer={faq.answer}
          index={index}
        />
      ))}
    </div>
  );
}

export default FAQ;
